import * as actionTypes from '../action-types';
import md5 from 'md5';
import { message } from 'antd';
import history from '@/containers/history';
import Cookies from 'js-cookie';
import { loginIn, getMsgNum } from '@/api/api';
import utils from '@/api/util';

export const login = (values = {}, rememberPassChecked, setValue, generateCheckCode) => {
  return async dispatch => {
    try {
      let params = Object.assign({}, values, {
        password: md5(values.password)
      });
      console.log(params);
      loginIn(params, result => {
        console.log(result);
        if (result.statusCode !== 1000) {
          message.error(result.message);
          console.log("异常")
          setValue('sureLoading', false);
          // if(result.statusCode === 9005){
          generateCheckCode(result.checkCode);
          // }
          return
        };
        dispatch({
          type: actionTypes.LOGIN_IN,
          user: result,
        });
        utils.addCookie('JSESSIONID', result.JSESSIONID, 14, '/')
        if (rememberPassChecked) {
          localStorage.setItem('userName_' + values.username, values.password);
        };
        localStorage.setItem('user', JSON.stringify(result));
        window.less.modifyVars({
          '@primary-color': '#' + result.color,
          '@btn-primary-bg': '#' + result.color,
        });
        setTimeout(() => {
          setValue('sureLoading', false)
          history.push('/homePage')
        }, 100)
      }, err => {
        console.log(err);
        setValue('sureLoading', false)
      });

    } catch (err) {

    }
  }
}

export const updateUserInfo = (user) => {
  return {
    type: actionTypes.USERINFO_UPDATE,
    user: user
  }
}


// export const getUserInfo=(user)=>{
//     return{
//       type:actionTypes.USERINFO_UPDATE,
//       user:user
//     }
// }

export const loginOut = () => {
  history.replace('/login');
  return {
    type: actionTypes.LOGIN_OUT
  }
}

//loading状态，true为显示，false不显示
export const isShowLoading = (bool) => ({
  type: "IS_SHOW_LOADING",
  bool
})